import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { BenefitsService } from '../../services/benefits.service';
import { MenuItem } from '../../interfaces/menu-item.interface';
import { ButtonComponent } from '../button/button.component';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { LinkComponent } from '@components/link/link.component';
import { AnalyticsService } from 'app/services/analytics.service';
import { environment } from '../../../environments/environment';
import { ApiService, UserInfo } from 'app/services/api.service';

@Component({
    selector: 'app-discover-benefits',
    standalone: true,
    imports: [CommonModule, MenuItemComponent, ButtonComponent, TranslateModule,LinkComponent],
    templateUrl: './discover-benefits.component.html',
    styleUrls: ['./discover-benefits.component.scss'],
})
export class DiscoverBenefitsComponent implements OnInit {
    menuItems: MenuItem[] = []
    selectedItem$ = this.benefitsService.getSelectedMenuItem()
    public isLoyalty2026Active: boolean = environment.loyalty2026
    isPopupOpen: boolean = false
    currentPopupIndex: number = 0
    userInfo: UserInfo
    loyaltyTcUrl: string | null = null
    popupBenefits = [
        { id: 'real_rewards', key: 'real_rewards', image: 'recompensas.jpg' },
        { id: 'custom_displays', key: 'custom_displays', image: 'Display.jpg' },
        { id: 'featured_recognition', key: 'featured_recognition', image: 'Reconocimiento.jpg' },
        { id: 'exclusive_networking', key: 'exclusive_networking', image: 'Eventos.jpg' },
        { id: 'early_launches', key: 'early_launches', image: 'novedades.jpg' },
        { id: 'professional_visibility', key: 'professional_visibility', image: 'Locator.jpg' }
    ]

    constructor(private benefitsService: BenefitsService,
                private router: Router,
                private analytics: AnalyticsService,
                private api: ApiService,
                private translate: TranslateService

    ) {}

    private translations(){
        this.translate.get([
            'benefits_kb.loyalty_2026.discover_missing_benefits',
            'benefits_kb.discover_your_benefits',
            'benefits_kb.loyalty_2026.professional_visibility.subtitle',
            'benefits_kb.loyalty_2026.professional_visibility.subtitle_premium',
            'benefits_kb.loyalty_2026.real_rewards.subtitle',
            'benefits_kb.loyalty_2026.real_rewards.subtitle_premium',
            // Popup translations (HTML lines 190–200)
            'benefits_kb.loyalty_2026.real_rewards.label',
            'benefits_kb.loyalty_2026.real_rewards.popup_title',
            'benefits_kb.loyalty_2026.real_rewards.popup_content',
            'benefits_kb.loyalty_2026.real_rewards.popup_button',
            'benefits_kb.loyalty_2026.real_rewards.popup_description1',

            'benefits_kb.loyalty_2026.custom_displays.label',
            'benefits_kb.loyalty_2026.custom_displays.popup_title',
            'benefits_kb.loyalty_2026.custom_displays.popup_content',
            'benefits_kb.loyalty_2026.custom_displays.popup_button',

            'benefits_kb.loyalty_2026.featured_recognition.label',
            'benefits_kb.loyalty_2026.featured_recognition.popup_title',
            'benefits_kb.loyalty_2026.featured_recognition.popup_content',
            'benefits_kb.loyalty_2026.featured_recognition.popup_button',

            'benefits_kb.loyalty_2026.exclusive_networking.label',
            'benefits_kb.loyalty_2026.exclusive_networking.popup_title',
            'benefits_kb.loyalty_2026.exclusive_networking.popup_content',
            'benefits_kb.loyalty_2026.exclusive_networking.popup_button',

            'benefits_kb.loyalty_2026.early_launches.label',
            'benefits_kb.loyalty_2026.early_launches.popup_title',
            'benefits_kb.loyalty_2026.early_launches.popup_content',
            'benefits_kb.loyalty_2026.early_launches.popup_button',

            'benefits_kb.loyalty_2026.professional_visibility.label',
            'benefits_kb.loyalty_2026.professional_visibility.popup_title',
            'benefits_kb.loyalty_2026.professional_visibility.popup_content',
            'benefits_kb.loyalty_2026.professional_visibility.popup_button',
            'benefits_kb.loyalty_2026.professional_visibility.popup_description1',
        ])
    }

    ngOnInit(): void {
        this.menuItems = this.benefitsService.getMenuItems()
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
        })
        this.api.getLoyaltyTc().subscribe({
            next: (res) => (this.loyaltyTcUrl = res.url ?? null),
            error: () => (this.loyaltyTcUrl = null),
        })
    }

    onSelectMenuItem(id: string): void {
        this.benefitsService.selectMenuItem(id)
    }

    mapBenefitId(id: string): string {
        switch (id) {
            case 'points': return 'points-program';
            case 'special-prices': return 'special-prices';
            case 'business-promotion': return 'promote';
            case 'events': return 'events';
            case 'extra-points': return 'more-points';
            case 'exclusive-colors': return 'exclusive-colours';
            case 'visit': return 'visit-headquarters';
            default: return id;
        }
    }


    goToMyRewards() {
        this.router.navigate(['/my-rewards'])
    }

    nextItem() {
        const current = this.benefitsService.getSelectedMenuItemValue()
        const idx = this.menuItems.findIndex((item) => item.id === current.id)
        const nextIdx = (idx + 1) % this.menuItems.length
        const nextId = this.menuItems[nextIdx].id
        this.benefitsService.selectMenuItem(nextId)
    }

    prevItem() {
        const current = this.benefitsService.getSelectedMenuItemValue()
        const idx = this.menuItems.findIndex((item) => item.id === current.id)
        const prevIdx = (idx - 1 + this.menuItems.length) % this.menuItems.length
        const prevId = this.menuItems[prevIdx].id
        this.benefitsService.selectMenuItem(prevId)
    }

    openPopup(index: number) {
        this.currentPopupIndex = index
        this.isPopupOpen = true
        document.body.style.overflow = 'hidden'
    }

    closePopup() {
        this.isPopupOpen = false
        document.body.style.overflow = 'auto'
    }

    nextPopup() {
        this.currentPopupIndex = (this.currentPopupIndex + 1) % this.popupBenefits.length
    }

    prevPopup() {
        this.currentPopupIndex = (this.currentPopupIndex - 1 + this.popupBenefits.length) % this.popupBenefits.length
    }

    getCurrentBenefit() {
        return this.popupBenefits[this.currentPopupIndex]
    }

    goToMySales(){
        this.router.navigate(['/my-sales'])
    }

    goToMySamples() {
        this.router.navigate(['/my-samples'])
    }

    requestExposition() {
        // Navegar a solicitud de exposición
        this.router.navigate(['/my-displays']);
    }

    getDiscoverBenefitsTitle(): string {
        if (!this.userInfo?.loyaltyLevel) return ''
        const level = this.userInfo.loyaltyLevel.toLowerCase()
        if (level === 'advanced') {
            return 'benefits_kb.loyalty_2026.discover_missing_benefits'
        }
        return 'benefits_kb.discover_your_benefits'
    }

    getProfessionalVisibilitySubtitle(): string {
        if (!this.userInfo?.loyaltyLevel) return 'benefits_kb.loyalty_2026.professional_visibility.subtitle'
        const level = this.userInfo.loyaltyLevel.toLowerCase()
        if (level === 'premium') {
            return 'benefits_kb.loyalty_2026.professional_visibility.subtitle_premium'
        }
        return 'benefits_kb.loyalty_2026.professional_visibility.subtitle'
    }

    getRealRewardsSubtitle(): string {
        if (!this.userInfo?.loyaltyLevel) return 'benefits_kb.loyalty_2026.real_rewards.subtitle'
        const level = this.userInfo.loyaltyLevel.toLowerCase()
        if (level === 'premium') {
            return 'benefits_kb.loyalty_2026.real_rewards.subtitle_premium'
        }
        return 'benefits_kb.loyalty_2026.real_rewards.subtitle'
    }
}
